import type { PaymentPubSubEvent } from "@@/shared/pubsub-events/payments/payment-pubsub-event";
import type {
    PaymentSocketEventBase} from "./payment-socket-event-base";
import {
    createPaymentSocketEventBase
} from "./payment-socket-event-base";
import { createPaymentSocketEventData } from "./payment-socket-event-data";
import type { PaymentSocketEventTypeName } from "./payment-socket-event-type-name";

type TypeName = Extract<PaymentSocketEventTypeName, "fulfilled">;
type PaymentFulfilledSocketEvent = PaymentSocketEventBase<TypeName>;

const createPaymentFulfilledSocketEvent = (
    event: PaymentPubSubEvent,
): PaymentFulfilledSocketEvent => {
    return createPaymentSocketEventBase<TypeName>({
        for: event.data.paymentFor,
        triggeredBy: event.triggeredBy,
        triggeredAt: event.triggeredAt,
        data: createPaymentSocketEventData({ event }),
        type: "payment:fulfilled",
        tags: [],
    });
};
export { createPaymentFulfilledSocketEvent };
export type { PaymentFulfilledSocketEvent };
